import React from "react";
import { Badge, Box, Grid, Icon, Text } from "~/components-shared";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { helpers } from "~/lib/helpers";
const StyledBox = styled(Box)`
  position: relative;
  border: 1px solid ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.borders.primary;
}};
`;
const StyledGridCell = styled(Grid.Cell)`
  border-right: 1px solid ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.borders.primary;
}};
`;
const StyledIconUp = styled(Icon)`
  margin-top: -0.25em;
  border-radius: 50%;
  color: white;
  background-color: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.colors.primary.main;
}};
`;
const StyledIconDown = styled(Icon)`
  margin-top: -0.25em;
  border-radius: 50%;
  color: white;
  background-color: #a65ae3;
`;
const StyledBadge = styled(Badge)`
  border: 1px solid ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.borders.primary;
}};
  border-radius: 0.5rem;
`;
const StyledHeading = styled(Box)`
  border-radius: 8px;
`;
const TopicAISummaryRevenueCard = _ref5 => {
  let {
    revenue
  } = _ref5;
  const {
    t
  } = useTranslation();
  const prospectiveRevenue = {
    "In Progress": revenue["In Progress"],
    "Closed lost": revenue["Closed Lost"]
  };
  const existingRevenue = {
    "Closed Won": revenue["Closed Won"]
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    fontSize: 4,
    weight: "semiBold",
    display: "block",
    s: {
      mt: 5,
      mb: 2
    }
  }, t("TopicAISummarizeCard.mappedRevenue")), /*#__PURE__*/React.createElement(Box, {
    id: "summary-revenue",
    s: {
      p: 3,
      mx: -3,
      my: -1
    }
  }, /*#__PURE__*/React.createElement(StyledBox, {
    s: {
      p: 0
    },
    fullWidth: true,
    rounded: true
  }, /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    gap: 0,
    fullWidth: true
  }, /*#__PURE__*/React.createElement(StyledGridCell, {
    s: {
      px: 4,
      py: 2
    }
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 3,
    weight: "semiBold",
    color: "textSecondary",
    display: "block"
  }, t("TopicAISummarizeCard.prospectiveRevenue")), /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    gap: 2,
    template: "50% 50%",
    fullWidth: true
  }, Object.entries(prospectiveRevenue).map(_ref6 => {
    let [key, value] = _ref6;
    return /*#__PURE__*/React.createElement(Grid.Cell, {
      key: key
    }, /*#__PURE__*/React.createElement(StyledHeading, {
      color: "translucent",
      s: {
        px: 2,
        py: 1,
        mt: 2,
        mb: 2
      }
    }, /*#__PURE__*/React.createElement(Text, {
      fontSize: 3,
      display: "block"
    }, key)), /*#__PURE__*/React.createElement(Grid, {
      cols: 2,
      gap: 6,
      fullWidth: true
    }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
      fontSize: 3.5,
      weight: "semiBold",
      display: "block"
    }, value?.count > 0 ? /*#__PURE__*/React.createElement(StyledIconUp, {
      scale: 3.5,
      s: {
        p: 0.2,
        mr: 1
      },
      src: "chevron",
      display: "inline-block"
    }) : value?.count < 0 && /*#__PURE__*/React.createElement(StyledIconDown, {
      scale: 3.5,
      s: {
        p: 0.2,
        mr: 1
      },
      src: "chevron",
      display: "inline-block",
      rotate: 180
    }), value?.count ? `${Math.abs(value.count).toLocaleString()}` : "-"), !!value?.countPct && /*#__PURE__*/React.createElement(StyledBadge, {
      s: {
        px: 1,
        py: 0,
        mt: 1
      },
      display: "inline-block",
      color: "greyTransparent",
      weight: "semiBold"
    }, `${value.countPct > 0 ? "+" : "-"}${Math.abs(value.countPct).toLocaleString("en-US", {
      style: "percent",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })}`)), /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
      fontSize: 3.5,
      weight: "semiBold",
      display: "block"
    }, value?.amount > 0 ? /*#__PURE__*/React.createElement(StyledIconUp, {
      scale: 3.5,
      s: {
        p: 0.2,
        mr: 1
      },
      src: "chevron",
      display: "inline-block"
    }) : value?.amount < 0 && /*#__PURE__*/React.createElement(StyledIconDown, {
      scale: 3.5,
      s: {
        p: 0.2,
        mr: 1
      },
      src: "chevron",
      display: "inline-block",
      rotate: 180
    }), value?.amount ? `${value.currency}${helpers.formatMoneyAmount(Math.abs(value.amount))}` : "-"), !!value?.amountPct && /*#__PURE__*/React.createElement(StyledBadge, {
      s: {
        px: 1,
        py: 0,
        mt: 1
      },
      display: "inline-block",
      color: "greyTransparent",
      weight: "semiBold"
    }, `${value.amountPct > 0 ? "+" : "-"}${Math.abs(value.amountPct).toLocaleString("en-US", {
      style: "percent",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })}`))));
  }))), /*#__PURE__*/React.createElement(Grid.Cell, {
    s: {
      px: 4,
      py: 2
    }
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 3,
    weight: "semiBold",
    color: "textSecondary",
    display: "block"
  }, t("TopicAISummarizeCard.existingRevenue")), /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    gap: 2,
    fullWidth: true
  }, Object.entries(existingRevenue).map(_ref7 => {
    let [key, value] = _ref7;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: key
    }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(StyledHeading, {
      color: "translucent",
      s: {
        px: 2,
        py: 1,
        mt: 2,
        mb: 2
      }
    }, /*#__PURE__*/React.createElement(Text, {
      fontSize: 3,
      display: "block"
    }, key)), /*#__PURE__*/React.createElement(Grid, {
      cols: 2,
      gap: 6
    }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
      fontSize: 3.5,
      weight: "semiBold",
      display: "block"
    }, value?.count > 0 ? /*#__PURE__*/React.createElement(StyledIconUp, {
      scale: 3.5,
      s: {
        p: 0.2,
        mr: 1
      },
      src: "chevron",
      display: "inline-block"
    }) : value?.count < 0 && /*#__PURE__*/React.createElement(StyledIconDown, {
      scale: 3.5,
      s: {
        p: 0.2,
        mr: 1
      },
      src: "chevron",
      display: "inline-block",
      rotate: 180
    }), value?.count ? `${Math.abs(value.count).toLocaleString()}` : "-"), !!value?.countPct && /*#__PURE__*/React.createElement(StyledBadge, {
      s: {
        px: 1,
        py: 0,
        mt: 1
      },
      display: "inline-block",
      color: "greyTransparent",
      weight: "semiBold"
    }, `${value.countPct > 0 ? "+" : "-"}${Math.abs(value.countPct).toLocaleString("en-US", {
      style: "percent",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })}`)), /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
      fontSize: 3.5,
      weight: "semiBold",
      display: "block"
    }, value?.amount > 0 ? /*#__PURE__*/React.createElement(StyledIconUp, {
      scale: 3.5,
      s: {
        p: 0.2,
        mr: 1
      },
      src: "chevron",
      display: "inline-block"
    }) : value?.amount < 0 && /*#__PURE__*/React.createElement(StyledIconDown, {
      scale: 3.5,
      s: {
        p: 0.2,
        mr: 1
      },
      src: "chevron",
      display: "inline-block",
      rotate: 180
    }), value?.amount ? `${value.currency}${helpers.formatMoneyAmount(Math.abs(value.amount))}` : "-"), !!value?.amountPct && /*#__PURE__*/React.createElement(StyledBadge, {
      s: {
        px: 1,
        py: 0,
        mt: 1
      },
      display: "inline-block",
      color: "greyTransparent",
      weight: "semiBold"
    }, `${value.amountPct > 0 ? "+" : "-"}${Math.abs(value.amountPct).toLocaleString("en-US", {
      style: "percent",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })}`)))), /*#__PURE__*/React.createElement(Grid.Cell, {
      key: `key_${value?.tcv}`
    }, /*#__PURE__*/React.createElement(StyledHeading, {
      color: "translucent",
      s: {
        px: 2,
        py: 1,
        mt: 2,
        mb: 2
      }
    }, /*#__PURE__*/React.createElement(Text, {
      fontSize: 3,
      display: "block"
    }, t("TopicAISummarizeCard.tcv"))), /*#__PURE__*/React.createElement(Text, {
      fontSize: 3.5,
      weight: "semiBold",
      display: "block"
    }, value?.tcv > 0 ? /*#__PURE__*/React.createElement(StyledIconUp, {
      scale: 3.5,
      s: {
        p: 0.2,
        mr: 1
      },
      src: "chevron",
      display: "inline-block"
    }) : value?.tcv < 0 && /*#__PURE__*/React.createElement(StyledIconDown, {
      scale: 3.5,
      s: {
        p: 0.2,
        mr: 1
      },
      src: "chevron",
      display: "inline-block",
      rotate: 180
    }), value?.tcv ? `${value.currency}${helpers.formatMoneyAmount(Math.abs(value.tcv))}` : "-"), !!value?.tcvPct && /*#__PURE__*/React.createElement(StyledBadge, {
      s: {
        px: 1,
        py: 0,
        mt: 1
      },
      display: "inline-block",
      color: "greyTransparent",
      weight: "semiBold"
    }, `${value.tcvPct > 0 ? "+" : "-"}${Math.abs(value.tcvPct).toLocaleString("en-US", {
      style: "percent",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })}`)));
  })))))));
};
export default TopicAISummaryRevenueCard;